import classNames from "classnames";
import { Container, Heading4, OrderedList } from "shared/components";

import styles from "./Content040.module.scss";

export const Content040 = ({ payload }) => {
  const title = payload?.title ?? "";
  const template = payload?.template ?? "light";
  const list = payload?.list ?? [];

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container>
        <div className={styles.block}>
          <Heading4 className={styles.title} color="dark">
            {title}
          </Heading4>
          <div className={styles.content}>
            <OrderedList
              items={list}
              appearance="bold"
              className={styles.list}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content040;
